import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import queryString from 'query-string';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useAppSelector } from 'app/config/storeConfig/hooks';
import { getGlobalSettings } from 'app/appState/model/selectors/getGlobalSettings';

const OPEN_APP_TIMEOUT_MS = 1500;
const MOBILE_USER_AGENT = /iPhone|iPad|iPod|Android/i;

// Public landing page for the payment gateway's success/failure redirect (set on the Viva
// source). The mobile app opens the gateway in a system browser and can't watch its
// navigation, so this hands control back to the app through its URL scheme (the app's
// package name, from the global settings); everyone else (desktop, or no app installed)
// falls through to the regular web page.
export const PaymentReturnPage: FC = () => {
  const { status } = queryString.parse(window.location.search);
  const navigate = useNavigate();
  const globalSettings = useAppSelector(getGlobalSettings);

  useEffect(() => {
    if (!globalSettings) {
      return undefined;
    }

    if (globalSettings.mobilePackage && MOBILE_USER_AGENT.test(navigator.userAgent)) {
      const paymentStatus = status === 'failed' ? 'failed' : 'success';

      window.location.href = `${globalSettings.mobilePackage}://payment-result?status=${paymentStatus}`;
    }

    const timer = setTimeout(() => {
      navigate(status === 'failed' ? AppRoutes.PAYMENT_FAILED : AppRoutes.PAYMENT_SUCCESS, { replace: true });
    }, OPEN_APP_TIMEOUT_MS);

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalSettings]);

  return null;
};
